import React from 'react';
import ReactGA from 'react-ga';
import { BrowserRouter as Router } from 'react-router-dom';

import { GlobalProvider } from './AppContext';
import { Layout } from './components/Layout';
import { WebRouter } from './router';

function App() {
  //const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  const TRACKING_ID = 'UA-261324497-1';
  ReactGA.initialize(TRACKING_ID);

  return (
    <Router>
      <GlobalProvider>
        <WebRouter />
      </GlobalProvider>
    </Router>
  );
}

export default App;
